import PropTypes from 'prop-types';
import React from 'react';
import FacilityAddress from '../FacilityAddress';

const SelectedFacilityInfoAlert = ({ facility }) => {
  if (!facility) return null;

  return (
    <va-alert status="info">
      <h2 slot="headline">Your current selection</h2>
      <p>
        You selected this VA medical center or clinic location where the Veteran
        receives or will receive care.
      </p>
      <FacilityAddress facility={facility} />
      <p>
        If you want to keep this facility, select <strong>Continue</strong>.
      </p>
      <p>
        If you want a different facility, use the <strong>Search</strong> box to
        select a new facility.
      </p>
    </va-alert>
  );
};

SelectedFacilityInfoAlert.propTypes = {
  facility: PropTypes.object,
};

export default React.memo(SelectedFacilityInfoAlert);
